import React, { useEffect } from "react";
import Index from "./pages/Index";

//Css
//import "./assets/vendor/switcher/switcher.css";
//import "./assets/vendor/swiper/swiper-bundle.min.css";

import "./assets/css/style.css";


function App() {
  useEffect(() => {
    // Suppress LightGallery license warning in development
    const originalWarn = console.warn;
    console.warn = (...args) => {
      const message = args.join(' ');
      if (message.includes('lightGallery') && message.includes('license key')) {
        // Suppress this specific warning
        return;
      }
      originalWarn.apply(console, args);
    };

    return () => {
      console.warn = originalWarn;
    };
  }, []);

  return (
    <>
      <Index />
    </>
  );
}

export default App;
